
import React, { useState, StyleSheet } from 'react';
import QRCode from 'qrcode.react';
import {
    Row,
    Col,
    Button,
    Modal,
    ModalBody,
} from "reactstrap";
import { authenticationService } from '_services';
import { handleResponse } from '_helpers';

const TSBooking = (props) => {
    //class TSList extends Component {

    const [renderItem, setRenderItem] = useState([]);
    const [modal2, setModal2] = useState(false);
    const [modalConfirm, setModalConfirm] = useState(false);
    const [modalCancel, setModalCancel] = useState(false);
    const [AppointDatetime, setAppointDatetime] = useState("");
    const [BookingNumber, setBookingNumber] = useState("");
    const [BookingID, setBookingID] = useState("");
    const [icon, setIcon] = useState("far fa-question-circle");

    const liffId = { confirm: '1654063801-JpnXVx2a', tele: '1654063801-PwXBy90W', profile: '1654063801-mPYn4Dba', visit: '1654063801-JAvgrW63', visitBooking: '1654063801-5QXvb928' }
    const liff = window.liff;

    liff.init({
        liffId: liffId.visitBooking
    })
    .then(() => {

    })
    .catch((err) => {

    });


    var moment = require('moment');
    require('moment/locale/th');
    const currentUser = authenticationService.currentUserValue;

    React.useEffect(() => {

        if (currentUser) {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json-patch+json',
                    'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
                }
            };

            fetch('/api/v1/mybookings', requestOptions)
                //.then(response => response.json())
                .then(handleResponse)
                .then(
                    (result) => {
                        setRenderItem(result.data);

                        result.data.map((post) => {
                            if (post.bookingStatus == 0 && moment(new Date()).format("YYYY/MM/DD") == moment(post.appointDatetime).format("YYYY/MM/DD")) {
                                setAppointDatetime(post.appointDatetimeText)
                                setBookingID(post.bookingID)
                                setModalConfirm(true)
                            }
                        });
                       
                    },
                    (error) => {
                        //alert(error);
                    }
                )
        }
        /*
        document.body.classList.add("landing-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        return function cleanup() {
            document.body.classList.remove("landing-page");
            document.body.classList.remove("sidebar-collapse");
        };
        */
    }, []);

    const handleConfirm = (dt, bookingID) => {
        setAppointDatetime(dt)
        setBookingID(bookingID)
        setModalConfirm(true)
    }
    const handleCancel = (dt, bookingID) => {
        setAppointDatetime(dt)
        setBookingID(bookingID)
        setModalCancel(true)
    }

    const handleBookingNumber = (dt, bookingno) => {
        setAppointDatetime(dt)
        setBookingNumber(bookingno)
        setModal2(true)
    }

    const handleStatus = (evt, status) => {
        evt.preventDefault();
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            },
            body: JSON.stringify({
                "bookingStatus": status,
            })
        };

        fetch('/api/v1/bookings/updatestatus/' + BookingID, requestOptions)
            .then(handleResponse)
            .then(
                (result) => {
                    if (liff.isInClient()) {
                        //alert('1');
                        var txt = (status == 1) ? "#ยืนยันการมารับบริการ" : (status == -1) ? "#ยกเลิกนัดหมาย" : "";

                        var THDate = moment(result.data.appointDatetime).add(543, 'year').format('Do MMMM YYYY');
                        var AppointTime = result.data.appointTime;

                        liff.sendMessages([{
                            'type': 'text',
                            //'text': 'ทดสอบ'
                            'text': `${txt} - ${currentUser.fullName} วันที่ ${THDate} เวลา ${AppointTime.substring(0, 5)} น. `
                        }]).then(function () {
                            liff.closeWindow();
                        }).catch(function (error) {
                            window.alert('Error sending message: ' + error);
                        });

                    } else {
                        var txt = (status == 1) ? "#ยืนยันการมารับบริการ" : (status == -1) ? "#ยกเลิกนัดหมาย" : "";

                        var THDate = moment(result.data.appointDatetime).add(543, 'year').format('Do MMMM YYYY');
                        var AppointTime = result.data.appointTime;
                        console.log(`${txt} - ${currentUser.fullName} วันที่ ${THDate} เวลา ${AppointTime.substring(0, 5)} น. `)

                        setModalConfirm(false);
                        setModalCancel(false);

               
                    }
                },
                (error) => {
                    alert(error);
                }
            )
    }


    const content = renderItem.map((post) => 
        <Row key={post.bookingID} style={{ fontSize: '1em', padding: '10px 10px', borderBottom: '1px solid #dddddd' }}>
            <Col md="3" xs="12">
                <div style={{ float: 'left', clear: 'both', paddingRight: '5px', fontWeight: 'bold' }} className="d-block d-sm-none">วันที่</div> {post.appointDatetimeText} 
            </Col>
            <Col md="2" xs="12">
                <div style={{ float: 'left', clear: 'both', paddingRight: '5px', fontWeight: 'bold' }} className="d-block d-sm-none">ประเภท</div>{post.serviceTypeName}
            </Col>
            <Col md="3" xs="12">
                <div style={{ float: 'left', clear: 'both', paddingRight: '5px', fontWeight: 'bold' }} className="d-block d-sm-none">สถานะ</div> {post.bookingStatusName}
    
            </Col>

            <Col md="4" xs="12">
      
                    <Button color="primary" size="sm" onClick={e => handleBookingNumber(post.appointDatetimeText, post.bookingNumber)} >
                        <i className="fas fa-qrcode"></i> QRCode {/*post.bookingNumber*/}
                    </Button>
     
                {
                    (post.bookingStatus >= -1 && post.bookingStatus <= 0) ?
                        <Button color="success" size="sm" onClick={e => handleConfirm(post.appointDatetimeText, post.bookingID)} >
                            <i className="fas fa-calendar-check"></i> ยืนยัน
                        </Button>
                        :
                        <div></div>
                }

                {
                    (post.bookingStatus >= 0 && post.bookingStatus <= 1) ?
                        <Button color="danger" size="sm" onClick={e => handleCancel(post.appointDatetimeText, post.bookingID)} >
                            <i className="fas fa-calendar-times"></i> ยกเลิก
                        </Button>
                        :
                        <div></div>
                }

      
            
            </Col>
        </Row > 
    );

    return (
        <>
            <div /*style={{ backgroundColor: '#2ca8ff1f' }}*/>
                <Row style={{ fontWeight: 'bold', fontSize: '1em', padding: '10px 10px', borderBottom: '2px solid #dddddd' }}>
                    <Col md="3" xs="6" className="d-none d-sm-block">
                        วันที่นัด
                    </Col>
                    <Col md="2" xs="6" className="d-none d-sm-block">
                        ประเภท
                    </Col>
                    <Col md="3" xs="12" className="d-none d-sm-block">
                        สถานะ
                    </Col>
                    <Col md="4" xs="12" className="d-none d-sm-block">
                        จัดการ
                    </Col>
                </Row>
                {content}
            </div>

            <Modal
                modalClassName="modal-info" /*modal-mini modal-info*/
                toggle={() => setModalConfirm(false)}
                isOpen={modalConfirm}
            >
                <div className="modal-header justify-content-center">
                    <div className="modal-profile">
                        <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                    </div>
                </div>
                <ModalBody className="text-center">
                    <p>{(icon != "fa fa-spinner fa-w-16 fa-spin fa-lg") ? "ยืนยันการมารับบริการ" : "กำลังบันทึกข้อมูล"}</p>
                    <p>คุณสะดวกมารับบริการ</p>
                    <p>วันที่ {AppointDatetime} หรือไม่ ?</p>
                    <p className="text-danger"> หากไม่สะดวกมากรุณายกเลิกการนัดหมาย</p>
                </ModalBody>

                <div className="modal-footer">
                    <Button
                        className="btn-neutral"
                        color="link"
                        type="button"
                        onClick={() => setModalConfirm(false)}
                    >
                        <i className="far fa-times-circle"></i> ปิด
                    </Button>

                    <Button
                        className="btn-neutral"
                        color="danger"
                        type="button"
                        onClick={e => handleStatus(e, -1)}
                    >
                        <i className="far fa-calendar-times"></i> ยกเลิกนัดหมาย
                    </Button>

                    <Button
                        className="btn-neutral"
                        color="success"
                        type="button"
                        onClick={e => handleStatus(e, 1)}
                    >
                        <i className="far fa-calendar-check"></i> ยืนยัน
                    </Button>
                </div>
            </Modal>

            <Modal
                modalClassName="modal-danger" /*modal-mini modal-info*/
                toggle={() => setModalCancel(false)}
                isOpen={modalCancel}
            >
                <div className="modal-header justify-content-center">
                    <div className="modal-profile">
                        <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                    </div>
                </div>
                <ModalBody className="text-center">
                    <p>{(icon != "fa fa-spinner fa-w-16 fa-spin fa-lg") ? "ยกเลิกนัดหมาย" : "กำลังบันทึกข้อมูล"}</p>
                    <p>คุณต้องการยกเลิกนัดหมาย</p>
                    <p>วันที่ {AppointDatetime} หรือไม่ ?</p>
                </ModalBody>

                <div className="modal-footer">
                    <Button
                        className="btn-neutral"
                        color="link"
                        type="button"
                        onClick={() => setModalCancel(false)}
                    >
                        <i className="far fa-times-circle"></i> ปิด
                    </Button>

                    <Button
                        className="btn-neutral"
                        color="danger"
                        type="button"
                        onClick={e => handleStatus(e, -1)}
                    >
                        <i className="far fa-calendar-times"></i> ยกเลิกนัดหมาย
                    </Button>
                </div>
            </Modal>


            <Modal
                modalClassName="modal-info" /*modal-mini modal-info*/
                toggle={() => setModal2(false)}
                isOpen={modal2}
            >
                <div className="modal-header justify-content-center">
                    <div className="modal-profile">
                        <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                    </div>
                </div>
                <ModalBody className="text-center">
                    <p>{(icon != "fa fa-spinner fa-w-16 fa-spin fa-lg") ? "รายละเอียดการนัดหมาย" : "กำลังบันทึกข้อมูล"}</p>
                    <p>วันที่นัดหมาย {AppointDatetime}</p>
                    <p className="text-center"><QRCode size={200} value={BookingNumber} /></p>
                    <p> เลขที่นัดหมาย {BookingNumber} </p>
                    <p> &nbsp; </p>
                    <p className="text-danger"> กรุณามาก่อนเวลานัดหมาย 15 นาที </p>
                </ModalBody>

                <div className="modal-footer">
                    <Button
                        className="btn-neutral"
                        color="link"
                        type="button"
                        onClick={() => setModal2(false)}
                    >
                        <i className="far fa-times-circle"></i> ปิด
                    </Button>
                </div>
            </Modal>
        </>
    );
}

export default TSBooking;